var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{attrs:{"showAddBtn":false,"showFilter":false,"showSearch":true,"showExportation":false}},[_vm._v("الشاحنات")]),_c('main-table',{attrs:{"fields":_vm.fields,"baseURL":_vm.VUE_APP_TRANSPORTATION_LINK,"status-url":'vehicles/status',"list_url":'vehicles'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }